import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {CyClass} from "../../../../../../../../common/cy-classes";
import {GamePlayPcHeaderBarGameTitleBox} from "../../boxes/game-title/game-play-pc-header-bar-game-title.box";
import React from "react";

export const GamePlayPcHeaderBarGameTitleComponent = observer(
    class GamePlayPcHeaderBarGameTitleComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {
        render() {
            return (
                <GamePlayPcHeaderBarGameTitleBox className={CyClass('cy-game-navbar-game-name')}>
                    {this.props.gameContext.gameInfo.title}
                </GamePlayPcHeaderBarGameTitleBox>
            );
        }
    }
);